import { useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Unknown routes: go back to the previous in-app page when history allows,
 * otherwise replace with the homepage.
 */
const NotFoundRedirect = () => {
  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (typeof window === 'undefined') return;

    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/', { replace: true });
    }
  }, [navigate]);

  return null;
};

export default NotFoundRedirect;
